/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Change_PasswordInputs */

const en_settings_change_password = /** @type {(inputs: Settings_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Password`)
};

const es_settings_change_password = /** @type {(inputs: Settings_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar contraseña`)
};

const fr_settings_change_password = /** @type {(inputs: Settings_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer le mot de passe`)
};

const de_settings_change_password = /** @type {(inputs: Settings_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort ändern`)
};

const ja_settings_change_password = /** @type {(inputs: Settings_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードを変更`)
};

const zh_settings_change_password = /** @type {(inputs: Settings_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修改密码`)
};

const ar_settings_change_password = /** @type {(inputs: Settings_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير كلمة المرور`)
};

const id_settings_change_password = /** @type {(inputs: Settings_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubah Kata Sandi`)
};

const it_settings_change_password = /** @type {(inputs: Settings_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia Password`)
};

const ru_settings_change_password = /** @type {(inputs: Settings_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сменить пароль`)
};

const pt_settings_change_password = /** @type {(inputs: Settings_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar Senha`)
};

const ko_settings_change_password = /** @type {(inputs: Settings_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호 변경`)
};

/**
* | output |
* | --- |
* | "Change Password" |
*
* @param {Settings_Change_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const settings_change_password = /** @type {((inputs?: Settings_Change_PasswordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Change_PasswordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_change_password(inputs)
	if (locale === "es") return es_settings_change_password(inputs)
	if (locale === "fr") return fr_settings_change_password(inputs)
	if (locale === "de") return de_settings_change_password(inputs)
	if (locale === "ja") return ja_settings_change_password(inputs)
	if (locale === "zh") return zh_settings_change_password(inputs)
	if (locale === "ar") return ar_settings_change_password(inputs)
	if (locale === "id") return id_settings_change_password(inputs)
	if (locale === "it") return it_settings_change_password(inputs)
	if (locale === "ru") return ru_settings_change_password(inputs)
	if (locale === "pt") return pt_settings_change_password(inputs)
	return ko_settings_change_password(inputs)
});